import { RootState } from '@types';

export const selectPricingData = (state: RootState) => {
    return state.pricing.data;
};

export const selectHasPricingData = (state: RootState) => {
    return Boolean(state.pricing.data);
};

export const selectBulkPrices = (state: RootState) => {
    return state.pricing.bulkPricesData;
};

export const selectBatchCapacity = (state: RootState) => {
    return state.pricing.batchCapacity;
};

export const selectIsPricingLoading = (state: RootState) => {
    return state.pricing.isLoading || state.pricing.isBulkPricesLoading;
};

export const selectPricingErrors = (state: RootState) => {
    return state.pricing.errors;
};

export const selectPricingWarnings = (state: RootState) => {
    return state.pricing.warnings;
};

export const selectHasPricingErrors = (state: RootState) => {
    return Boolean(state.pricing.errors?.length);
};

export const selectPricingTbd = (state: RootState) => {
    return state.pricing.tbd;
};
